import React from 'react';
import { MapPin, Phone, Mail, Instagram } from 'lucide-react';
import { restaurantInfo } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-black text-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <h3 className="text-3xl font-serif font-bold mb-4">La Grande Brune</h3>
            <p className="text-gray-400 leading-relaxed">
              Plus qu'un lieu, une signature
            </p>
          </div>

          {/* Address */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Adresse</h4>
            <div className="flex items-start space-x-3 text-gray-400">
              <MapPin size={20} className="mt-1 flex-shrink-0" />
              <p className="leading-relaxed">{restaurantInfo.address}</p>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <div className="space-y-3">
              <a
                href={`tel:${restaurantInfo.phone}`}
                className="flex items-center space-x-3 text-gray-400 hover:text-white transition-colors duration-200"
              >
                <Phone size={20} />
                <span>{restaurantInfo.phone}</span>
              </a>
              <a
                href={`mailto:${restaurantInfo.email}`}
                className="flex items-center space-x-3 text-gray-400 hover:text-white transition-colors duration-200"
              >
                <Mail size={20} />
                <span>{restaurantInfo.email}</span>
              </a>
            </div>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Suivez-nous</h4>
            <a
              href={`https://instagram.com/${restaurantInfo.instagram}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-3 text-gray-400 hover:text-white transition-colors duration-200"
            >
              <Instagram size={20} />
              <span>@{restaurantInfo.instagram}</span>
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800 text-center">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} La Grande Brune. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
